import { useEffect, useRef } from 'react'
import { StyledCameraDisplayContainer, StyledCameraDisplayVideo } from 'components/Selfiebooth/CameraDisplay/styled'
import Controls from './controls'

interface CameraDisplayProps {
  stream: MediaStream;
  stopCamera: () => void;
  capturePhoto: (video: HTMLVideoElement | null) => void;
  switchCamera: () => void;
}

const CameraDisplay = ({ stream, stopCamera, capturePhoto, switchCamera }: CameraDisplayProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if(videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream])

  if (!stream) return null;

  return <>
    <StyledCameraDisplayContainer>
      <StyledCameraDisplayVideo ref={videoRef} autoPlay playsInline />
      <Controls stopCamera={stopCamera} capturePhoto={() => capturePhoto(videoRef.current)} switchCamera={switchCamera} />
    </StyledCameraDisplayContainer>
  </>
}

export default CameraDisplay;